import React from 'react';
import { 
  HelpCircle, 
  Shield, 
  DollarSign, 
  Clock, 
  Code, 
  Users, 
  Zap
} from 'lucide-react';

const TipsSidebar = () => {
  const tips = [
    {
      icon: Shield,
      title: 'Безопасность',
      description: 'Всегда проводите аудит безопасности смарт-контрактов перед запуском в продакшн.'
    },
    {
      icon: DollarSign,
      title: 'Бюджетирование',
      description: 'Заложите 15-20% бюджета на непредвиденные расходы и изменения требований.'
    },
    {
      icon: Clock,
      title: 'Планирование',
      description: 'Начните с MVP и постепенно добавляйте функциональность, чтобы сократить время до запуска.'
    },
    {
      icon: Code,
      title: 'Смарт-контракты',
      description: 'Простые контракты снижают затраты на разработку, тестирование и аудит безопасности.'
    },
    {
      icon: Users,
      title: 'Команда',
      description: 'Найдите разработчиков с опытом работы с выбранным блокчейном, а не просто общими знаниями.'
    },
    {
      icon: Zap,
      title: 'Производительность',
      description: 'Учитывайте ограничения блокчейна (TPS, газ) при проектировании высоконагруженных систем.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Советы по блокчейн-проектам
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Нужна консультация?
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Получите бесплатную консультацию по разработке вашего блокчейн-проекта и оптимизации бюджета.
            </p>
            <button className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
              Запросить консультацию
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;